
export const getLatLng = (company) => {
    try {
        const addressData = company.addressInstanceAttribute;
        if (!addressData.address) {
            return;
        }
        const lat = parseFloat(addressData.address.lat);
        const lng = parseFloat(addressData.address.lng);

        if (isNaN(lat) || isNaN(lng)) {
            return;
        }

        return new window.google.maps.LatLng(lat, lng);
    } catch (error) {
        return null;
    }
}

export const getName = (company) => {
    try {
        return company.defaultInstanceAttribute.content;
    } catch (error) {
        return ""
    }
}

export const getAddress = (company) => {
    try {
        return company.addressInstanceAttribute.address.formattedAddress;
    } catch (error) {
        return ""
    }
}

export const getCompanyId = (company) => {
    try {
        return company.defaultInstanceAttribute.id
    } catch (error) {
        return ""
    }
}

export const getDistance = (matrix) => {
    try {
        return matrix.rows[0].elements[0].distance.humanReadable;
    } catch (error) {
        return null
    }
}

export const getDuration = (matrix) => {
    try {
        return matrix.rows[0].elements[0].duration.humanReadable;
    } catch (error) {
        return null
    }
}


export const getOtherCompanyInfo = (company) => {
    try {
        const data = [];
        const otherInfo = company.otherInstanceAttributes;
        console.log("otherInfo", otherInfo)

        otherInfo.forEach((info) => {
            if (info?.isAddress || !info?.content || !info?.templateAttribute?.name) {
                return;
            }

            const attribute = info.templateAttribute.name;
            const content = info.content;

            data.push({ attribute: attribute, content: content });
        })

        return data;
    } catch (error) {
        return null
    }
}